import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_x_menu_item = _resolveComponent("x-menu-item");
  const _component_a_menu = _resolveComponent("a-menu");
  return _openBlock(), _createBlock(_component_a_menu, {
    "open-keys": $setup.openKeyRef,
    "onUpdate:openKeys": _cache[0] || (_cache[0] = $event => $setup.openKeyRef = $event),
    "selected-keys": $setup.selectKeysRef,
    "onUpdate:selectedKeys": _cache[1] || (_cache[1] = $event => $setup.selectKeysRef = $event),
    theme: $props.theme,
    mode: "inline"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (item, idx) => {
      return _openBlock(), _createBlock(_component_x_menu_item, {
        key: idx,
        name: item.name || idx + 1,
        item: item,
        onItemClick: $setup.handleItemClick
      }, null, 8, ["name", "item", "onItemClick"]);
    }), 128))]),
    _: 1
  }, 8, ["open-keys", "selected-keys", "theme"]);
}